import browser, { dom } from '../../../../browser';
import ocSmileys from '../openclassrooms';

const smileysCodes = Object.keys(ocSmileys);

function escapeRegexp(regexpString) {
  return regexpString.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

function sortFromIndex(a, b) {
  return a.index - b.index;
}

function createImageFromSmileyCode(smileyCode) {
  const image = browser.document.createElement('img');
  image.src = ocSmileys[smileyCode];
  image.setAttribute('title', smileyCode);
  image.setAttribute('alt', smileyCode);

  return image;
}

function getSplitDataFromSmileyCode(textNode, smileyCode) {
  const codeLength = smileyCode.length;

  const splitsData = [];
  let startIndexOf = 0;
  let index;

  do {
    index = textNode.nodeValue.indexOf(smileyCode, startIndexOf);

    const end = index + codeLength;

    if (index >= 0) {
      splitsData.push({
        index,
        smileyCode,
        codeLength,
      });

      startIndexOf += end;
    }
  } while (index >= 0);

  return splitsData;
}

function splitTextNode(textNode) {
  let clone = textNode.cloneNode();
  const splitedNodeData = {
    originalNode: textNode,
    replacedNodes: [clone],
  };

  const splitsData = smileysCodes.reduce((allDatas, smileyCode) => {
    const newData = getSplitDataFromSmileyCode(clone, smileyCode);

    if (!newData.length) {
      return allDatas;
    }

    const smileyRegexp = new RegExp(escapeRegexp(smileyCode), 'g');
    clone.nodeValue = clone.nodeValue.replace(smileyRegexp, '_'.repeat(smileyCode.length));

    return [...allDatas, ...newData];
  }, []);

  if (!splitsData.length) {
    return null;
  }

  let deltaIndex = 0;

  splitsData.sort(sortFromIndex).forEach((data) => {
    const image = createImageFromSmileyCode(data.smileyCode);
    splitedNodeData.replacedNodes.push(image);

    const nextNode = clone.splitText(data.index - deltaIndex);
    nextNode.nodeValue = nextNode.nodeValue.substring(data.codeLength);
    splitedNodeData.replacedNodes.push(nextNode);

    deltaIndex += clone.nodeValue.length + data.codeLength;
    clone = nextNode;
  });

  return splitedNodeData;
}

function getSplittedTextNodes(textNodes) {
  return textNodes.reduce((allNodes, textNode) => {
    const splittedNodes = splitTextNode(textNode);

    if (splittedNodes) {
      return [...allNodes, splittedNodes];
    }

    return allNodes;
  }, []);
}

function parse(domContainer) {
  function textNodesExclusionFunction(node) {
    const notParsedTags = ['code', 'pre', 'samp'];
    const nodeTagName = node.tagName ? node.tagName.toLowerCase() : null;
    const shouldBeParsed = notParsedTags.every((tag) => tag !== nodeTagName);

    return !nodeTagName || shouldBeParsed;
  }

  const textNodes = dom.getTextNodes(domContainer, textNodesExclusionFunction);
  const splittedNodes = getSplittedTextNodes(textNodes);

  splittedNodes.forEach((splittedNode) => {
    const { parentNode } = splittedNode.originalNode;
    splittedNode.replacedNodes.forEach((node) => {
      parentNode.insertBefore(node, splittedNode.originalNode);
    });

    parentNode.removeChild(splittedNode.originalNode);
  });
}

export default {
  parse,
};
